import { hydrate } from 'svelte'
import VideoChapters from './VideoChapters.svelte'

export default (target, props) => hydrate(VideoChapters, { target, props })
